import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { MyCompany } from '@/types';

// Raw membership shape returned by GET /me/companies (user_companies join).
type MembershipRow = {
  company_id: number;
  is_primary: boolean;
  removed_at: string | null;
  company: { id: number; name: string; code: string; is_active: boolean };
};

// Lists the companies the current collaborator belongs to. This endpoint is
// requireAuth-only (ignores X-Active-Company), so it is safe to call before the
// active company is resolved. Removed memberships are filtered out.
export function useMyCompanies() {
  return useQuery({
    queryKey: ['my-companies'],
    queryFn: () => api.get<MembershipRow[]>('/me/companies'),
    select: (res): MyCompany[] =>
      res.data
        .filter((m) => m.removed_at === null)
        .map((m) => ({
          company_id: m.company_id,
          name: m.company.name,
          code: m.company.code,
          is_primary: m.is_primary,
        })),
  });
}
